// @ts-strict-ignore
/**
 * @fileoverview POSTWS handler for the "/engagement/async/segments_and_filters_preview/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { engagementAsyncSegmentsAndFiltersPreviewAppGroupIdCacheKey } from "./constants";
import type {
  PostwsEngagementAsyncSegmentsAndFiltersPreviewAppGroupIdPayload,
  PostwsEngagementAsyncSegmentsAndFiltersPreviewAppGroupIdProps,
} from "./types";
import { isEngagementAsyncSegmentsAndFiltersPreviewAppGroupIdResult } from "./validators";

export const engagementAsyncSegmentsAndFiltersPreviewAppGroupId = reactQueryPostWebsocketAdapter(
  engagementAsyncSegmentsAndFiltersPreviewAppGroupIdCacheKey,
  async (
    signal,
    {
      timeout = 180000,
      jobToken,
      estimated,
      filters,
      segmentIds,
      meta,
      appGroupId,
      tagNames,
      reachableChannels,
      subscriptionGroupId,
      subscriptions,
      isFunnelStats,
      sampleSizePercentage,
    }: PostwsEngagementAsyncSegmentsAndFiltersPreviewAppGroupIdProps
  ): Promise<{}> => {
    const payload: PostwsEngagementAsyncSegmentsAndFiltersPreviewAppGroupIdPayload = {
      timeout,
      job_token: jobToken,
      filters,
      segment_ids: segmentIds,
      estimated,
      tag_names: tagNames,
      reachable_channels: reachableChannels,
      subscription_group_id: subscriptionGroupId,
      subscriptions,
      meta,
      is_funnel_stats: isFunnelStats,
      sample_size_percentage: sampleSizePercentage ?? undefined,
    };

    return fetch(
      `/engagement/async/segments_and_filters_preview/${appGroupId}`,
      "POST",
      payload,
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isEngagementAsyncSegmentsAndFiltersPreviewAppGroupIdResult
);
